var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83301 20.2513H22.833V21.7513H1.83301V20.2513ZM19.3905 6.75134C19.6722 6.46998 19.8304 6.0882 19.8304 5.69009C19.8304 5.29197 19.6722 4.91019 19.3905 4.62884L16.7055 1.94384C16.4242 1.66217 16.0424 1.50391 15.6443 1.50391C15.2461 1.50391 14.8644 1.66217 14.583 1.94384L3.33301 13.1938V18.0013H8.14051L19.3905 6.75134ZM15.6405 3.00134L18.333 5.69384L16.083 7.94384L13.3905 5.25134L15.6405 3.00134ZM4.83301 16.5013V13.8088L12.333 6.30884L15.0255 9.00134L7.52551 16.5013H4.83301Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.60ac9c65aa38d38720ab235bd3085eaf.svg";